module.exports = __webpack_public_path__ + "img/pp.ed026896.png";